<h4 class="title">
  {{ 'settings.account.delete.feedback.title' | transloco }}
</h4>
<p class="description">
  {{ 'settings.account.delete.feedback.description' | transloco }}
</p>

<feedback [showEmail]="showEmail()" />
